import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes =  [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/new-game',
        name: 'newGame',
        component: () => import(/* webpackChunkName: "about" */ '../views/NewGame.vue')
    },
    {
        path: '/your-move',
        name: 'YourMove',
        component: () => import(/* webpackChunkName: "about" */ '../views/YourMove.vue')
    },
    // {
    //     path: '/select-word',
    //     name: 'SelectWord',
    //     component: () => import(/* webpackChunkName: "about" */ '../views/SelectWord.vue')
    // },
    {
        path: '/finish',
        name: 'finish',
        component: () => import(/* webpackChunkName: "about" */ '../views/Finish.vue')
    }
]

const router = new VueRouter({
    mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
